<template>
    <div
        v-if="local_report"
        class="reportPreviewCard"
        :class="{'inset': inset}"
        @click="downloadReport(local_report.id, local_report.file_name)"
    >
        <v-layout
            row
            wrap
        >
            <div
                v-if="!inset"
                style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
            >
                <v-icon>
                    {{ 'mdi-file-chart' }}
                </v-icon>
            </div>
            <div>
                <b>{{ reportType }}</b>
                <br/><br/>
                <span>{{ convertToLocal(local_report.completed_at) }}</span>
            </div>
            <v-spacer/>
            <div>
                <br/>
                <v-icon style="margin-right: 10px;">
                    {{ 'mdi-download' }}
                </v-icon>
            </div>
        </v-layout>
    </div>
</template>

<script>
import api from '@/api'

export default{
    name: 'ReportPreview',
    props: ['report', 'id', 'inset'],
    data () {
        return {
            local_report: null,
            searching: false
        }
    },
    created () {
        if (this.report) {
            this.local_report = JSON.parse(JSON.stringify(this.report))
        } else {
            if (this.id)
                this.fetch()
        }
    },
    methods: {
        fetch () {
            this.searching = true
            api.reports.reports.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_report = data
                })
        },
        downloadReport (id, name) {
            api.reports.reports.downloadReport(id)
                .then(response => {
                    let blob = new Blob([response.data])
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = name
                    link.click()
                })
        }
    },
    computed: {
        reportType () {
            switch (this.local_report.type) {
                case 'userform':
                    return "Userform Report"
                case 'contact file report':
                    return "Contact File Report"
                case 'form file report':
                    return "Form File Report"
            }
        }
    }
}
</script>

<style scoped>
.reportPreviewCard {
    background:rgba(0,0,0,0.05);
    padding:5px;
    border-radius:5px;
    cursor:pointer;
}

.reportPreviewCard:hover {
    background:rgba(0,0,0,0.1);
}

.inset {
    background: unset;
    padding: unset !important;
}

.small-title {
    font-size: 12px !important;
    font-weight: 900 !important;
}

a {
    text-decoration: none;
    color: black;
}

span::first-letter {
    text-transform: capitalize;
}
</style>